const faqs = [
  {
    q: '天天影院是否需要注册或付费？',
    a: '完全不需要。天天影院是纯免费在线观影平台，所有电影资源均可直接播放，无需注册账号，更没有任何隐藏收费项目。我们坚持为影迷提供零门槛的观影服务。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '天天影院全面适配电脑、平板和手机浏览器，无需安装任何软件即可在线观看。全站提供高清画质（1080P），部分热门影片支持超清4K播放，配合智能码率自适应技术，根据您的网络环境自动匹配合适清晰度。',
  },
  {
    q: '影片更新速度快吗？能看到最新上映的电影吗？',
    a: '我们的内容团队每天实时追踪院线新片与网络热映资源，每日稳定更新30部以上影片。最新电影大全涵盖动作片在线、喜剧片免费看、科幻片高清播放等多个板块，确保您不会错过任何一部热门新片。',
  },
  {
    q: '播放卡顿怎么办？需要下载播放器吗？',
    a: '天天影院采用先进的CDN加速和多线分发架构，绝大部分影片都能实现流畅播放。如遇偶尔卡顿，建议切换播放线路（页面内提供多线路选择）或降低清晰度。不需要下载任何播放器，浏览器直接播放即可。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          关于天天影院，您可能关心的问题都在这里
        </p>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line text-sm"></i>
                  </span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}